<app-supplier-round-list-ssy1230detail [state]="viewState.Edit"></app-supplier-round-list-ssy1230detail>